<template>
  <div>
    <doctor-table
      :canDelete="true"
      viewRoute="ClinicDoctorEdit"
      :canCreate="true"
      viewDetailRoute="ClinicDoctorDetailView"
      createRoute="ClinicDoctorCreate"
    />
  </div>
</template>

<script>
import doctorTable from '../../components/doctors/doctorTable.vue';

export default {
  components: {
    doctorTable,
  },
  data: () => ({}),
};
</script>
